/* eslint-disable no-restricted-globals */
import { chunk, flatten } from 'lodash';
import { FieldTypes } from '@ubeya/shared/hooks/account/useFields';
import * as api from '@ubeya/shared/services/api';
import { mappedArray } from '@ubeya/shared/utils/array';

const EMPLOYEES_FIELDS_PAGE_SIZE = 500;

export const fetchEmployeesWithFields = async ({ accountId, branchId, employeeIds = [] }) => {
  const employees = flatten(
    await Promise.all(
      chunk(employeeIds, EMPLOYEES_FIELDS_PAGE_SIZE).map(async (employeeIdsChunk) => {
        const { data } = await api.fetchEmployees({
          accountId,
          branches: [branchId],
          page: 1,
          pageSize: EMPLOYEES_FIELDS_PAGE_SIZE,
          whitelistIds: employeeIdsChunk.join('#'),
          includes: ['withFields']
        });

        return data || [];
      })
    )
  );

  return mappedArray(employees.map(({ id, fields }) => ({ id, fields })));
};

const EMPLOYEES_FILES_BATCH_SIZE = 10;

export const fetchEmployeesSignedFields = async ({ accountId, employeeIds = [] }) => {
  const employees = [];

  for (const employeeIdsChunk of chunk(employeeIds, EMPLOYEES_FILES_BATCH_SIZE)) {
    employees.push(
      ...(await Promise.all(
        employeeIdsChunk.map(async (employeeId) => {
          const { data } = await api.fetchEmployee({ accountId, employeeId }).catch(() => ({}));
          return { id: employeeId, fields: data?.fields || [] };
        })
      ))
    );
  }

  return mappedArray(employees);
};

export const reduceEmployeeFields = (accountFields = [], mappedFieldsValue = [], employeeFields = {}) => {
  const accountFieldsMap = (accountFields || []).reduce((output, field) => {
    output[field.id] = field;
    return output;
  }, {});

  const employeeFieldsMapping =
    accountFields?.length > 0 &&
    (employeeFields || []).reduce((output, current) => {
      const { id, value } = current;
      if (!mappedFieldsValue[id]) {
        return output;
      }

      const formattedValue = mappedFieldsValue[id](value) || '';
      const field = accountFieldsMap[id];

      const outputValue =
        field?.fieldTypeId === FieldTypes.FIELD_TYPE_NUMBER && !isNaN(formattedValue)
          ? Number(formattedValue)
          : formattedValue;

      output[id] = { ...current, value: outputValue };
      return output;
    }, {});

  return (accountFields || []).reduce((output, { id, name }) => {
    output[name] = employeeFieldsMapping[id]?.value || '';
    return output;
  }, {});
};
